






import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'DemographicsAgeBarChart'

  vue:
    props: ['data']

    components: {
      BoxChart,
    }

    data: ->
      chart: null

    methods:
      cleanUp: ->
        @chart?.destroy()

      draw: ->
        data = Object.values(@data)
        labels = Object.keys(@data)
          .map((key) => key.replace('age_', ''))
          .map((key) => key.replace(/(\d+)_(\d+)/, '$1 - $2'))
          .map((key) => @$options.filters.formatTitle(key))

        @chart = new Chart(@$refs.chart, {
          plugins: [ChartDataLabels]
          type: 'bar'
          data: {
            labels: labels
            datasets: [{
              data: data
              backgroundColor: ChartUtility.COLORS.blue
            }]
          }
          options: {
            maintainAspectRatio: false
            indexAxis: 'y'
            categoryPercentage: 1
            barPercentage: 1
            maxBarThickness: 24
            borderRadius: 4
            layout: {
              padding: {
                right: 32
              }
            }
            scales: {
              x: {
                display: false
              }
              y: {
                grid: {
                  display: false
                }
              }
            }
            plugins: {
              legend: {
                display: false
              }
              datalabels: {
                formatter: (value, context) =>
                  value + '%'
                anchor: 'end'
                align: 'end'
                color: ChartUtility.COLORS.slate
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        })

export default VueOptions.vue settings
